<ng-form class="k-form k-form-md" [formGroup]="appFixedCutterData" *ngIf="ProductLine$ | async as  Productline">
    <fieldset>
        <legend style="border-bottom: 1px solid #e2e8f0;">Fixed Cutter Parameters</legend>
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <kendo-formfield>
                    <kendo-label for="Size">Size</kendo-label>
                    <kendo-numerictextbox formControlName="size" id="Size" name="Size" [decimals]="decimals"
                        [format]="format" type="number" [min]="0" [max]="36" [step]="0.125" id="BitSize" name="BitSize"
                        cost-saving-factor="size" rta-status-factor="New" rta-status="Bit"
                        [inputAttributes]="inputModeDecimal"
                        [readonly]="(appFixedCutterData.get('size')?.value ?? 0) > 0 && !excluded"
                        (valueChange)="onUpdateSize($event)"></kendo-numerictextbox>
                    <kendo-formhint *ngIf="!excluded" style="color:darkcyan;">Pulled from
                        the model</kendo-formhint>
                    <kendo-formerror>Error: Bit size is required</kendo-formerror>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-3">
                <kendo-formfield>
                    <kendo-label for="BitCoreSize">Core Size</kendo-label>
                    <kendo-numerictextbox formControlName="coreSize" type="number" [decimals]="decimals"
                        [format]="format" [min]="0" [max]="36" [step]="0.125" id="BitCoreSize" name="BitCoreSize"
                        rta-status-factor="New" rta-status="Bit" [inputAttributes]="inputModeDecimal"
                        [readonly]="Productline !== 'Core Head'"
                        [spinners]="Productline === 'Core Head'"></kendo-numerictextbox>
                    <kendo-formhint *ngIf="Productline !== 'Core Head'" style="color:darkcyan;">Not
                        applicable</kendo-formhint>
                    <kendo-formerror>Error: Core size is required</kendo-formerror>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-3">
                <kendo-formfield>
                    <kendo-label for="BitType"><span style="width: 20%;">Type</span>
                        <span *ngIf="nomenclaturePending" class="override-pending-badge" title="A nomenclature override request is pending approval">Override Pending</span>
                    </kendo-label>
                    <kendo-textbox formControlName="type" type="text" id="BitType" name="BitType"
                        cost-saving-factor="BitType" rta-status-factor="SAPChange" rta-status="Bit">
                        <ng-template kendoTextBoxSuffixTemplate>
                            <button kendoButton fillMode="clear" kendoPopoverAnchor [popover]="nomenclatureOverridePopover" title="Request override"><kendo-svgicon [icon]="icons['gearIcon']"></kendo-svgicon></button>
                        </ng-template>
                    </kendo-textbox>
                    <kendo-formerror *ngIf="appFixedCutterData.get('type')?.hasError('required')">Error: Bit type is
                        required</kendo-formerror>
                    <kendo-formerror *ngIf="appFixedCutterData.get('type')?.hasError('pattern')">Error: Bit type format
                        is invalid</kendo-formerror>
                    <kendo-formhint *ngIf="!nomenclaturePending" style="color:darkcyan;">Contact Product Manager for advanced
                        options</kendo-formhint>
                    <kendo-formhint *ngIf="nomenclaturePending" style="color:#e65100; font-weight:500;">
                        ⚠ Override pending — order cannot be submitted until approved or retracted.
                    </kendo-formhint>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-3">
                <kendo-formfield>
                    <kendo-label for="BitLevel">Level</kendo-label>
                    <kendo-dropdownlist formControlName="level" id="BitLevel" name="BitLevel" cost-saving-factor="Level"
                        rta-status-factor="SAPChange" rta-status="span_bit" [data]="levelOptions" textField="name" [valuePrimitive]="true" valueField="id">
                    </kendo-dropdownlist>
                </kendo-formfield>
            </div>

        </div>
        <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-6 col-md-3 col-lg-3">
                <kendo-formfield>
                    <kendo-label for="BitHasSleeve">Has Sleeve</kendo-label>
                    <kendo-dropdownlist formControlName="sleeve" id="BitHasSleeve" name="BitHasSleeve" [data]="yesno"
                        textField="name" [valuePrimitive]="true" valueField="value" cost-saving-factor="HasSleeve"
                        rta-status-factor="Mod" rta-status="span_bit"></kendo-dropdownlist>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3">
                <kendo-formfield>
                    <kendo-label for="BitGaugeLength">Gauge Pad Length:</kendo-label>
                    <kendo-textbox formControlName="gaugeLength" id="BitGaugeLength" name="BitGaugeLength"
                        cost-saving-factor="GaugeLength" rta-status-factor="Mod" rta-status="span_bit"
                        [readonly]="(appFixedCutterData.get('gaugeLength')?.value ?? 0) > 0"></kendo-textbox>
                    <kendo-formhint style="color:darkcyan;">Pulled from the model</kendo-formhint>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3">
                <kendo-formfield>
                    <kendo-label for="OnePiece">One Piece?</kendo-label>
                    <kendo-dropdownlist formControlName="onePiece" id="OnePiece" name="OnePiece" [data]="yesno"
                        textField="name" [valuePrimitive]="true" valueField="value"
                        [readonly]="Productline !== 'Steel'"></kendo-dropdownlist>
                    <kendo-formhint *ngIf="Productline !== 'Steel'" style="color:darkcyan;">Not
                        applicable</kendo-formhint>
                </kendo-formfield>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3">
                <kendo-formfield>
                    <kendo-label for="Hardfacing">Body Hardfacing</kendo-label>
                    <kendo-dropdownlist formControlName="hardfacing" id="Hardfacing" name="Hardfacing" textField="name"
                        [valuePrimitive]="true" valueField="name" [data]="hardfacingOptions$| async"
                        [readonly]="Productline !== 'Steel'"></kendo-dropdownlist>
                    <kendo-formhint *ngIf="Productline !== 'Steel'" style="color:darkcyan;">Not
                        applicable</kendo-formhint>
                </kendo-formfield>
            </div>

            <div class="col-sm-12" style="margin-top: 10px;" *ngIf="bitInitial?.uppersection_Id">
                <div style="padding: .5rem .75rem;border-radius: 8px;background: #8b8b8b4f;border: dashed;">
                    <div kendoTypography variant="p">
                        <i>Note: Uppersection <span style="text-decoration: underline; font-weight: bold;"> {{
                                importedUpperDrawing }}</span> was imported from reference/model, to
                            change
                            this please update the uppersection in the model and rerun RTA Generator. <span
                                *ngIf="bitInitial?.breaker_Id">This uppersection defaults to use bit breaker <span
                                    style="text-decoration: underline; font-weight: bold;">{{ importedBreaker }}</span>,
                                if this breaker will not work please note that in the RTA description.</span></i>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</ng-form>

<kendo-popover #nomenclatureOverridePopover position="right">
  <ng-template kendoPopoverBodyTemplate>
    <div class="panel-content" style="min-width: 280px;">
      <h6 style="margin-top:0;">Request non-standard nomenclature</h6>

      <!-- Pending override status banner -->
      <div *ngIf="nomenclaturePending && pendingOverrideRequest" class="override-pending-banner">
        <div style="font-weight:600; margin-bottom:4px;">⏳ Override Request Pending</div>
        <div style="font-size:0.85em; color:#555;">
          <div><strong>Requested:</strong> {{ pendingOverrideRequest.nomenclatureRequested }}</div>
          <div><strong>Reason:</strong> {{ pendingOverrideRequest.justification }}</div>
        </div>
        <button kendoButton themeColor="error" fillMode="outline" style="width:100%; margin-top:8px;"
          [disabled]="nomenclatureCancelling"
          (click)="cancelOverrideRequest()">
          {{ nomenclatureCancelling ? 'Retracting...' : 'Retract Override Request' }}
        </button>
      </div>

      <form [formGroup]="nomenclatureOverrideForm" (ngSubmit)="submitNomenclatureOverride()" *ngIf="!nomenclaturePending">
        <kendo-label text="Requested nomenclature"></kendo-label>
        <kendo-textbox formControlName="nomenclature" placeholder="Enter desired nomenclature"></kendo-textbox>
        <kendo-formerror *ngIf="nomenclatureOverrideForm.get('nomenclature')?.hasError('required')">
          Nomenclature is required
        </kendo-formerror>

        <kendo-label class="k-display-block" text="Reason"></kendo-label>
        <kendo-textarea formControlName="justification" [rows]="3" placeholder="Explain why this nomenclature is needed"></kendo-textarea>
        <kendo-formerror *ngIf="nomenclatureOverrideForm.get('justification')?.hasError('required')">
          Justification is required
        </kendo-formerror>

        <kendo-label class="k-display-block" text="Your email" style="margin-top: 6px;"></kendo-label>
        <kendo-textbox formControlName="requesterEmail" placeholder="name@halliburton.com"></kendo-textbox>
        <kendo-formerror *ngIf="nomenclatureOverrideForm.get('requesterEmail')?.hasError('email')">
          Enter a valid email address
        </kendo-formerror>

        <div style="margin-top: 10px;">
          <button kendoButton themeColor="success" style="width: 100%; margin-bottom: 6px;"
            type="submit"
            [disabled]="nomenclatureSubmitting || nomenclatureOverrideForm.invalid">
            {{ nomenclatureSubmitting ? 'Submitting...' : 'Request override' }}
          </button>
        </div>
        <kendo-formhint style="color:darkcyan;">Request the ability to apply a non-standard nomenclature.</kendo-formhint>
      </form>

      <div *ngIf="nomenclatureMessage" style="color:#008b4a; margin-top:6px;">{{ nomenclatureMessage }}</div>
      <div *ngIf="nomenclatureError" style="color:#842029; margin-top:6px;">{{ nomenclatureError }}</div>
      <hr />
      <kendo-label class="k-display-block" text="Have an approval code?"></kendo-label>
      <form [formGroup]="nomenclatureOverrideForm">
        <kendo-textbox formControlName="overrideCode" placeholder="Enter code">
          <ng-template kendoTextBoxSuffixTemplate>
            <button kendoButton fillMode="clear" themeColor="primary" type="button"
              [disabled]="nomenclatureSubmitting"
              (click)="applyNomenclatureCode()">
              {{ nomenclatureSubmitting ? 'Validating...' : 'Apply code' }}
            </button>
          </ng-template>
        </kendo-textbox>
      </form>
    </div>
  </ng-template>
</kendo-popover>
